var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.selectClearAllNode')))]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.optionModel.selectClearAllNode),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "selectClearAllNode", $$v)
      },
      expression: "optionModel.selectClearAllNode"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb93e18","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-tree/tree-selectClearAllNode-editor.vue
// module id = null
// module chunks = 